import { render, staticRenderFns } from "./PostOp.vue?vue&type=template&id=fbb7a034"
import script from "./PostOp.vue?vue&type=script&lang=js"
export * from "./PostOp.vue?vue&type=script&lang=js"
import style0 from "./PostOp.vue?vue&type=style&index=0&id=fbb7a034&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports